import { useState } from "react"
import { Building2, Trash2, RefreshCw, Plus, ChevronRight, ClipboardList, Check } from "lucide-react"


const CompetitorComparison = ({ researchType, selectedCompanies, setSelectedCompanies, setShowSelectCompany, selectedPointOfViews=[], setSelectedPointOfViews, addedConditions, setAddedConditions, modifyOutline, processCreateReport, onMakeSlideClick, modifyOutlineButtonEnabled, makeReportButtonEnabled, makePptFlg, setMakePptFlg }) => {
  const [pointOfView, setPointOfView] = useState("")
  const [condition, setCondition] = useState("")

  const handleSubmitPointOfView = () => {
    if (pointOfView.trim() !== "") {
      setSelectedPointOfViews((prev) => {
        if (!prev.includes(pointOfView)) {  // 重複チェック
          return [...prev, pointOfView];
        }
        return prev;
      });
      setPointOfView("");
    }
  }

  const handleMakePptChange = (e) => {
    setMakePptFlg(e.target.checked)
  }

  const handlePointOfViewKeyDown = (e) => {
    if (e.nativeEvent.isComposing || e.keyCode === 229) {
      return;
    }

    if (e.key === 'Enter') {
      e.preventDefault(); // デフォルトの動作（フォーム送信など）を防止
      handleSubmitPointOfView();
    }
  };
  
  const handleAddCompany = () => {
    setShowSelectCompany(true)
    
  }

  const handleSubmitCondition = () => {
    if (condition.trim() !== "") {
      setAddedConditions((prev) => {
        if (!prev.includes(condition)) {  // 重複チェック
          return [...prev, condition];
        }
        return prev;
      });
      setCondition("")
    }
  }

  const handleConditionKeyDown = (e) => {
    if (e.nativeEvent.isComposing || e.keyCode === 229) {
      return;
    }

    if (e.key === 'Enter') {
      e.preventDefault(); // デフォルトの動作（フォーム送信など）を防止
      handleSubmitCondition();
    }
  };


  const onDeletePovClick = (view) => {
    setSelectedPointOfViews((prev) => prev.filter((v) => v !== view))
  }

  const onDeleteConditionClick = (condition) => {
    setAddedConditions((prev) => prev.filter((v) => v !== condition))
  }

  const deleteCompany = (secCode) => {
    setSelectedCompanies((prev) => prev.filter((company) => company.secCode !== secCode))
  }

  const getResearcTypeName = (researchType) => {
    switch (researchType) {
      case "companyAnalysis":
        return "企業分析";
      case "competitorComparison":
        return "競合分析";
      case "marketResearch":
        return "市場調査";
      case "others":
        return "その他";
      default:
        return "その他";
    }
  }

  return (
    <>
      <div className="text-xl font-semibold mb-4">{getResearcTypeName(researchType)}</div>
      <hr />
      <div className="space-y-[30px] mt-4">
        <div className="document-box">
          <div className="flex items-center mb-2 gap-2">
            <Building2 size={16} /><span>対象企業</span>
          </div>
          <div className="flex flex-wrap gap-2 text-xs">
            {selectedCompanies.map((company) => (
              <div key={company.secCode} className="rounded-full bg-gray-200 py-2 pl-4 pr-[30px] relative">
                <div>{company.companyName} ({company.secCode})</div>
                <div className="absolute right-[10px] top-1/2 transform -translate-y-1/2 cursor-pointer" onClick={() => deleteCompany(company.secCode)}>×</div>
              </div>
            ))}
            <button className="flex items-center gap-1 px-3 py-1.5 rounded-full border border-dashed border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200" onClick={handleAddCompany}>
              <Plus size={14} />
              <span>追加</span>
            </button>
          </div>
        </div>
        <hr />
        <div className="document-box">
          <div className="flex items-center mb-2 gap-2">
            <ClipboardList size={16} />
            <span>分析・評価項目</span>
          </div>
          <div className="flex flex-wrap gap-2 w-full mb-4">
            {selectedPointOfViews.map((view) => (
              <div key={view} className="rounded-full bg-gray-200 py-2 pl-4 pr-[30px] relative text-xs">
                <div className="whitespace-nowrap ">{view}</div>
                <div className="absolute right-[10px] top-1/2 transform -translate-y-1/2 cursor-pointer" onClick={() => onDeletePovClick(view)}>×</div>
              </div>
            ))}
          </div>
          <div className="flex gap-2 w-[240px]">
            <input
              className="w-full px-4 py-2 h-[30px] border rounded-full text-sm"
              value={pointOfView}
              placeholder="評価観点"
              onChange={(e) => setPointOfView(e.target.value)}
              onKeyDown={(e) => handlePointOfViewKeyDown(e)}
              rows="3"
            />
            <button className="px-4 py-2 w-[70px] h-[30px] flex justify-center items-center bg-green-500 text-white rounded-full hover:bg-green-600 text-sm" onClick={handleSubmitPointOfView}>
              追加
            </button>
          </div>
        </div>
        <hr />
        <div className="document-box">
          <label className="block mb-2">追加の要望</label>
          {addedConditions.length > 0 &&
            <ul>
              {addedConditions.map((condition) => (
                <li key={condition} className="flex items-center gap-2 py-2">
                  <Check className="h-3 w-3"/><span>{condition}</span><Trash2 size={14} onClick={() => onDeleteConditionClick(condition)} /></li>
                ))}
            </ul>
          }
          <div className="flex gap-2">
              <input
                className="w-full px-4 py-2 h-[30px] border rounded-full text-sm"
                value={condition}
                placeholder="分析に関する要望があればご記入ください"
                onChange={(e) => setCondition(e.target.value)}
                onKeyDown={(e) => handleConditionKeyDown(e)}
                rows="3"
              />
            <button className="px-4 py-2 w-[70px] h-[30px] flex justify-center items-center bg-green-500 text-white rounded-full hover:bg-green-600 text-sm" onClick={handleSubmitCondition}>
              追加
            </button>
          </div>
        </div>
        <div className="border-t">
          <div className="flex items-center justify-between mt-4">
            <div></div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="powerpoint"
                checked={makePptFlg}
                onChange={handleMakePptChange}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label htmlFor="powerpoint" className="text-sm font-medium text-gray-700">
                PowerPointを作成する
              </label>
            </div>
          </div>
          <div className="py-4 flex justify-between">
            <button
              className={`flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 transition-colors duration-200 ${modifyOutlineButtonEnabled ? "hover:bg-gray-50" : "bg-gray-400"}`}
              onClick={modifyOutline}
              disabled={!modifyOutlineButtonEnabled}
            >
              <span className="mr-2">アウトラインを修正</span>
              <RefreshCw size={12} />
            </button>
            <button
              className={`flex items-center gap-2 px-6 py-2 rounded-full shadow-lg transition-colors duration-200 ${makeReportButtonEnabled ? "bg-gradient-to-r from-emerald-500 to-teal-400 hover:from-emerald-600 hover:to-teal-500 text-white" : "bg-gray-400 text-gray-600"}`}
              onClick={processCreateReport}
              disabled={!makeReportButtonEnabled}
            >
              <span>資料作成開始</span>
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default CompetitorComparison